import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'RatingBadgeComponent',
  props: {
    personalRating: {}
  },
  setup(__props: any) {



const ratingClasses = {
  neutral: "bg-secondary text-alternative-gray border border-divider",
  excellent: "bg-success text-white shadow-sm",
  bad: "bg-error/15 text-error border border-error/20",
  good: "bg-success/15 text-success border border-success/20",
  weak: "bg-secondary text-alternative-gray border border-divider",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["px-2.5 py-1 rounded-full text-xs font-bold inline-block", ratingClasses[__props.personalRating]])
  }, _toDisplayString(_ctx.$t(
        `calculators.personal-date.full-day-report.hourlyTable.ratings.${__props.personalRating}`
      )), 3))
}
}

})